import Vue from 'vue';
import { environment } from 'services/apiConfigs';
import store from 'store';
import get from 'lodash/get';

const checkTokenRefresh = (response) => {
  if (response.data.token) {
    store.dispatch('refreshToken', response.data.token);
    delete response.data.token;
  }
};

export const sendLogEntry = (logEntry) => {
  logEntry.timeStamp = new Date().getTime();
  logEntry.duration = logEntry.endTime - logEntry.startTime;
  logEntry.environment = environment;
  logEntry.source = 'web';
  logEntry.school = get(store, [
    'getters',
    'getProfile',
    'school_info',
    'school_name',
  ]);

  const options = {
    method: 'POST',
    body: JSON.stringify(logEntry),
  };

  if (process.env.LOGGING_API_URL) {
    fetch(process.env.LOGGING_API_URL, options).catch(console.error);
  }
};

export const makeRequest = (action, url, payload, withCredentials) => {
  withCredentials = withCredentials || false;

  const logEntry = {
    url,
    startTime: new Date().getTime(),
    action,
  };

  // Handle case where action/url is invalid
  return Vue.$http[action](url, payload, { withCredentials })
    .then((response) => {
      logEntry.error = false;
      logEntry.endTime = new Date().getTime();
      // sendLogEntry(logEntry);
      checkTokenRefresh(response);
      return response;
    })
    .catch((error) => {
      logEntry.error = error;
      logEntry.endTime = new Date().getTime();
      // sendLogEntry(logEntry);
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/app/utils/requestLogger.js